import type { ReactNode } from 'react';
import { cx } from './cx';

/**
 * Status pill. SKILL.md maps the tones to meaning:
 *   accent  — good / confirmed
 *   outline — waiting / new
 *   neutral — everything else
 *   up/down — positive / negative figures
 */
export type TagTone = 'accent' | 'outline' | 'neutral' | 'up' | 'down';

const toneClass: Record<TagTone, string> = {
  accent: 'tag-accent',
  outline: 'tag-outline',
  neutral: 'tag-neutral',
  up: 'tag-up',
  down: 'tag-down',
};

export function Tag({
  tone = 'neutral',
  className,
  style,
  children,
}: {
  tone?: TagTone;
  className?: string;
  style?: React.CSSProperties;
  children: ReactNode;
}) {
  return (
    <span className={cx('tag', toneClass[tone], className)} style={style}>
      {children}
    </span>
  );
}
